/**
 * @file package table content
 * @author zhenglujie(zhenglujie@baidu.com))
 * Copyright (c) 2019-09-16 Baidu
 */
import React from 'react';

const renderContentOfPackage = (value, row, index) => {
    const obj = {
        children: value,
        props: {}
    };

    if (index === 8) {
        obj.props.colSpan = 0;
    }
    return obj;
}
const renderContentOfPackageMonthly = (value, row, index) => {
    const obj = {
        children: value,
        props: {}
    };
    if (index === 5) {
        obj.props.colSpan = 0;
    }
    return obj;
};
export let billingPackageOfQuarter = {
    head: [
        {
            title: '短网址季度套餐包',
            children: [
                {
                    title: '档位',
                    dataIndex: 'trafficType',
                    key: 'trafficType',
                    render: (text, record, index) => `${index + 1}`
                },
                {
                    title: '有效期（月）',
                    dataIndex: 'validityPeriod',
                    key: 'validityPeriod',
                    render: (text, _) => '3'
                },
                {
                    title: '价格（元）',
                    dataIndex: 'price',
                    key: 'price'
                },
                {
                    title: '点数',
                    dataIndex: 'count',
                    key: 'count'
                },
                // {
                //     title: '折扣',
                //     dataIndex: 'discount',
                //     key: 'discount',
                //     render: (text, row, index) => {
                //         const content = (
                //             <span>联系我们：
                //                     <a href="mailto:ext_dwz-help@baidu.com">{text}</a>
                //             </span>
                //         );
                //         if (index === 8) {
                //             return {
                //                 children: content,
                //                 props: {colSpan: 5}
                //             }
                //         };
                //         return text;
                //     }
                // },
                // {
                //     title: '点数单价',
                //     dataIndex: 'pointUnitPrice',
                //     key: 'pointUnitPrice',
                //     render: renderContentOfPackage
                // },
                // {
                //     title: '创建单价(1年有效)',
                //     dataIndex: 'create1YearUnitPrice',
                //     key: 'create1YearUnitPrice',
                //     render: (text, row, index) => {
                //         const content = (
                //             <span>
                //                 <span className="activity">{row.create1YearUnitPriceInAct}</span>
                //             </span>
                //         );
                //         if (index === 8) {
                //             return {
                //                 children: content,
                //                 props: {colSpan: 0}
                //             };
                //         };
                //         return content;
                //     }
                // },
                // {
                //     title: '创建单价(长期有效)',
                //     dataIndex: 'createLongTermUnitPrice',
                //     key: 'createLongTermUnitPrice',
                //     render: (text, row, index) => {
                //         const content = (
                //             <span>
                //                 <span className="activity">{row.createLongTermUnitPriceInAct}</span>
                //             </span>
                //         );
                //         if (index === 8) {
                //             return {
                //                 children: content,
                //                 props: {colSpan: 0}
                //             };
                //         };
                //         return content;
                //     }
                // },
                // {
                //     title: '跳转单价',
                //     dataIndex: 'redirectUnitPrice',
                //     key: 'redirectUnitPrice',
                //     render: renderContentOfPackage
                // }
            ]
        }
    ],
    body: [
    // {
    //     key: 1,
    //     price: '10',
    //     count: '1万',
    //     discount: '无',
    //     pointUnitPrice: '10元/万点',
    //     create1YearUnitPriceInAct: '10元/万条',
    //     createLongTermUnitPriceInAct: '20元/万条',
    //     redirectUnitPrice: '10元/万次'
    // },
    {
        key: 2,
        price: '90',
        count: '10万',
        discount: '9折',
        pointUnitPrice: '9元/万点',
        create1YearUnitPriceInAct: '9元/万条',
        createLongTermUnitPriceInAct: '18元/万条',
        redirectUnitPrice: '9元/万次'
    },
    {
        key: 3,
        price: '200',
        count: '25万',
        discount: '8折',
        pointUnitPrice: '8元/万点',
        create1YearUnitPriceInAct: '8元/万条',
        createLongTermUnitPriceInAct: '16元/万条',
        redirectUnitPrice: '8元/万次'
    },
    {
        key: 4,
        price: '700',
        count: '100万',
        discount: '7折',
        pointUnitPrice: '7元/万点',
        create1YearUnitPriceInAct: '7元/万条',
        createLongTermUnitPriceInAct: '14元/万条',
        redirectUnitPrice: '7元/万次'
    },
    {
        key: 5,
        price: '1500',
        count: '250万',
        discount: '6折',
        pointUnitPrice: '6元/万点',
        create1YearUnitPriceInAct: '6元/万条',
        createLongTermUnitPriceInAct: '12元/万条',
        redirectUnitPrice: '6元/万次'
    },
    {
        key: 6,
        price: '2500',
        count: '500万',
        discount: '5折',
        pointUnitPrice: '5元/万点',
        create1YearUnitPriceInAct: '5元/万条',
        createLongTermUnitPriceInAct: '10元/万条',
        redirectUnitPrice: '5元/万次'
    },
    // {
    //     key: 7,
    //     price: '9000',
    //     count: '2000万',
    //     discount: '4.5折',
    //     pointUnitPrice: '4.5元/万点',
    //     create1YearUnitPriceInAct: '4.5元/万条',
    //     createLongTermUnitPriceInAct: '9元/万条',
    //     redirectUnitPrice: '4.5元/万次'
    // },
    // {
    //     key: 8,
    //     price: '20000',
    //     count: '5000万',
    //     discount: '4折',
    //     pointUnitPrice: '4元/万点',
    //     create1YearUnitPriceInAct: '4元/万条',
    //     createLongTermUnitPriceInAct: '8元/万条',
    //     redirectUnitPrice: '4元/万次'
    // },
    // {
    //     key: 9,
    //     price: '联系我们',
    //     count: '大于5000万',
    //     discount: 'ext_dwz-help@baidu.com'
    // }
]};
export let billingPackageOfMonth = {
    head: [
        {
            title: '短网址包月套餐包',
            children: [
                {
                    title: '档位',
                    dataIndex: 'trafficType',
                    key: 'trafficType',
                    render: (text, record, index) => `${index + 6}`
                },
                {
                    title: '有效期（月）',
                    dataIndex: 'validityPeriod',
                    key: 'validityPeriod',
                    render: (text, _) => '1'
                },
                {
                    title: '价格（元）',
                    dataIndex: 'price',
                    key: 'price'
                },
                {
                    title: '点数',
                    dataIndex: 'count',
                    key: 'count'
                },
                // {
                //     title: '折扣',
                //     dataIndex: 'discount',
                //     key: 'discount',
                //     render: (text, row, index) => {
                //         const content = (
                //             <span>联系我们：
                //                 <a href="mailto:ext_dwz-help@baidu.com">{text}</a>
                //             </span>
                //         );
                //         if (index === 5) {
                //             return {
                //                 children: content,
                //                 props: {colSpan: 5}
                //             };
                //         };
                //         return text;
                //     }
                // },
                // {
                //     title: '点数单价',
                //     dataIndex: 'pointUnitPrice',
                //     key: 'pointUnitPrice',
                //     render: renderContentOfPackageMonthly
                // },
                // {
                //     title: '创建单价(1年有效)',
                //     dataIndex: 'create1YearUnitPrice',
                //     key: 'create1YearUnitPrice',
                //     render: (text, row, index) => {
                //         const content = (
                //             <span>
                //                 <span className="activity">{row.create1YearUnitPriceInAct}</span>
                //             </span>
                //         );
                //         if (index === 5) {
                //             return {
                //                 children: content,
                //                 props: {colSpan: 0}
                //             };
                //         };
                //         return content;
                //     }
                // },
                // {
                //     title: '创建单价(长期有效)',
                //     dataIndex: 'createLongTermUnitPrice',
                //     key: 'createLongTermUnitPrice',
                //     render: (text, row, index) => {
                //         const content = (
                //             <span>
                //                 <span className="activity">{row.createLongTermUnitPriceInAct}</span>
                //             </span>
                //         );
                //         if (index === 5) {
                //             return {
                //                 children: content,
                //                 props: {colSpan: 0}
                //             };
                //         };
                //         return content;
                //     }
                // },
                // {
                //     title: '跳转单价',
                //     dataIndex: 'redirectUnitPrice',
                //     key: 'redirectUnitPrice',
                //     render: renderContentOfPackageMonthly
                // }
            ]
        }
    ],
    body: [{
        key: 1,
        price: '3000',
        count: '682万',
        discount: '4.40',
        pointUnitPrice: '4.4元/万点',
        create1YearUnitPriceInAct: '4.4元/万条',
        createLongTermUnitPriceInAct: '8.8元/万条',
        redirectUnitPrice: '4.4元/万次'
    },
    // {
    //     key: 2,
    //     price: '5000',
    //     count: '1163万',
    //     discount: '4.30',
    //     pointUnitPrice: '4.3元/万点',
    //     create1YearUnitPriceInAct: '4.3元/万条',
    //     createLongTermUnitPriceInAct: '8.6元/万条',
    //     redirectUnitPrice: '4.3元/万次'
    // },
    {
        key: 3,
        price: '10000',
        count: '2857万',
        discount: '3.50',
        pointUnitPrice: '3.5元/万点',
        create1YearUnitPriceInAct: '3.5元/万条',
        createLongTermUnitPriceInAct: '7元/万条',
        redirectUnitPrice: '3.5元/万次'
    },
    // {
    //     key: 4,
    //     price: '20000',
    //     count: '6667万',
    //     discount: '3.00',
    //     pointUnitPrice: '3元/万点',
    //     create1YearUnitPriceInAct: '3元/万条',
    //     createLongTermUnitPriceInAct: '6元/万条',
    //     redirectUnitPrice: '3元/万次'
    // },
    {
        key: 5,
        price: '50000',
        count: '2亿',
        discount: '2.50',
        pointUnitPrice: '2.5元/万点',
        create1YearUnitPriceInAct: '2.5元/万条',
        createLongTermUnitPriceInAct: '5元/万条',
        redirectUnitPrice: '2.5元/万次'
    },
    // {
    //     key: 6,
    //     price: '联系我们',
    //     count: '大于2亿',
    //     discount: 'ext_dwz-help@baidu.com'
    // }
]};
export let billingPackageOfYear = {
    head: [
        {
            title: '短网址一年期订阅',
            children: [
                {
                    title: '档位',
                    dataIndex: 'trafficType',
                    key: 'trafficType',
                    render: (text, record, index) => `${index + 9}`
                },
                {
                    title: '有效期（月）',
                    dataIndex: 'validityPeriod',
                    key: 'validityPeriod',
                    render: (text, _) => '订阅12个月包'
                },
                {
                    title: '价格（元）',
                    dataIndex: 'price',
                    key: 'price'
                },
                {
                    title: '点数',
                    dataIndex: 'count',
                    key: 'count'
                },
                // {
                //     title: '折扣',
                //     dataIndex: 'discount',
                //     key: 'discount',
                //     render: (text, row, index) => {
                //         const content = (
                //             <span>联系我们：
                //                     <a href="mailto:ext_dwz-help@baidu.com">{text}</a>
                //             </span>
                //         );
                //         if (index === 5) {
                //             return {
                //                 children: content,
                //                 props: {colSpan: 6}
                //             };
                //         };
                //         return text;
                //     }
                // },
                // {
                //     title: '点数单价',
                //     dataIndex: 'pointUnitPrice',
                //     key: 'pointUnitPrice',
                //     render: renderContentOfPackageMonthly
                // },
                // {
                //     title: '创建单价(1年有效)',
                //     dataIndex: 'create1YearUnitPrice',
                //     key: 'create1YearUnitPrice',
                //     render: (text, row, index) => {
                //         const content = (
                //             <span>
                //                 <span className="activity">{row.create1YearUnitPriceInAct}</span>
                //             </span>
                //         );
                //         if (index === 5) {
                //             return {
                //                 children: content,
                //                 props: {colSpan: 0}
                //             };
                //         };
                //         return content;
                //     }
                // },
                // {
                //     title: '创建单价(长期有效)',
                //     dataIndex: 'createLongTermUnitPrice',
                //     key: 'createLongTermUnitPrice',
                //     render: (text, row, index) => {
                //         const content = (
                //             <span>
                //                 <span className="activity">{row.createLongTermUnitPriceInAct}</span>
                //             </span>
                //         );
                //         if (index === 5) {
                //             return {
                //                 children: content,
                //                 props: {colSpan: 0}
                //             };
                //         };
                //         return content;
                //     }
                // },
                // {
                //     title: '跳转单价',
                //     dataIndex: 'redirectUnitPrice',
                //     key: 'redirectUnitPrice',
                //     render: renderContentOfPackageMonthly
                // },
                // {
                //     title: '赠送',
                //     dataIndex: 'give',
                //     key: 'give',
                //     render: renderContentOfPackageMonthly
                // },

            ]
        }
    ],
    body: [{
        key: 1,
        price: '3万',
        count: '683万 * 12 = 8196万',
        discount: '3.66',
        pointUnitPrice: '3.66元/万点',
        create1YearUnitPriceInAct: '3.66元/万条',
        createLongTermUnitPriceInAct: '7.32元/万条',
        redirectUnitPrice: '3.66元/万次',
        give: '高级报表价值2000元（有效期1年）'
    },
    // {
    //     key: 2,
    //     price: '5万',
    //     count: '1164万 * 12 = 1.3968亿',
    //     discount: '3.58',
    //     pointUnitPrice: '3.58元/万点',
    //     create1YearUnitPriceInAct: '3.58元/万条',
    //     createLongTermUnitPriceInAct: '7.16元/万条',
    //     redirectUnitPrice: '3.58元/万次',
    //     give: '高级报表价值2000元（有效期1年）'
    // },
    {
        key: 3,
        price: '10万',
        count: '2858万 * 12 = 3.4296亿',
        discount: '2.92',
        pointUnitPrice: '2.92元/万点',
        create1YearUnitPriceInAct: '2.92元/万条',
        createLongTermUnitPriceInAct: '5.84元/万条',
        redirectUnitPrice: '2.92元/万次',
        give: '高级报表价值2000元（有效期1年）'
    },
    // {
    //     key: 4,
    //     price: '20万',
    //     count: '6668万 * 12 = 8.0016亿',
    //     discount: '2.50',
    //     pointUnitPrice: '2.5元/万点',
    //     create1YearUnitPriceInAct: '2.5元/万条',
    //     createLongTermUnitPriceInAct: '5元/万条',
    //     redirectUnitPrice: '2.5元/万次',
    //     give:'高级报表价值5000元（有效期1年）'
    // },
    {
        key: 5,
        price: '50万',
        count: '2.0001亿 * 12 = 24.0012亿',
        discount: '2.08',
        pointUnitPrice: '2.08元/万点',
        create1YearUnitPriceInAct: '2.08元/万条',
        createLongTermUnitPriceInAct: '4.16元/万条',
        redirectUnitPrice: '2.08元/万次',
        give:'高级报表价值5000元（有效期1年）'
    },
    // {
    //     key: 6,
    //     price: '联系我们',
    //     count: '大于24亿',
    //     discount: 'ext_dwz-help@baidu.com'
    // }
]
};
export let billingPackageOfYear2 = {
    head: [
        {
            title: '短网址一年期订阅',
            children: [
                {
                    title: '档位',
                    dataIndex: 'trafficType',
                    key: 'trafficType',
                    render: (text, record, index) => `${index + 12}`
                },
                {
                    title: '有效期（年）',
                    dataIndex: 'validityPeriod',
                    key: 'validityPeriod',
                    render: (text, _) => '订阅1个年包'
                },
                {
                    title: '价格（元）',
                    dataIndex: 'price',
                    key: 'price'
                },
                {
                    title: '点数',
                    dataIndex: 'count',
                    key: 'count'
                },
            ]
        }
    ],
    body: [{
        key: 1,
        price: '6000',
        count: '1000 万/年',
    },
    {
        key: 2,
        price: '10000',
        count: '2000 万/年',
    }]
};

export let advancedReport = {
    head: [
        {
            dataIndex: 'title',
            key: 'title',
            width: 100,
            className: 'column-money',
            // colSpan: 2,
            // render: (value, row, index) => {
            //     const obj = {
            //       children: value,
            //       props: {},
            //     };
            //     if (index === 0) {
            //       obj.props.rowSpan = 2;
            //       obj.props.colSpan = 2;
            //     }
            //     if (index === 1 || index === 3 || index === 5 || index === 6 || index === 8 || index === 10) {
            //       obj.props.rowSpan = 0;
            //     }
            //     if (index === 2 || index === 7 || index === 9) {
            //        obj.props.rowSpan = 2;
            //     }
            //     if (index === 4) {
            //        obj.props.rowSpan = 3;
            //     }
            //     return obj;
            // }
        },
        // {
        //     dataIndex: 'msg',
        //     key: 'msg',
        //     width: 220,
        //     className: 'column-money',
        //     colSpan: 0,
        //     render: (value, row, index) => {
        //         const obj = {
        //           children: value,
        //           props: {},
        //         };
        //         if (index === 0) {
        //           obj.props.rowSpan = 2;
        //           obj.props.colSpan = 0;
        //         }
        //         if (index === 1) {
        //           obj.props.rowSpan = 0;
        //         }
        //         return obj;
        //     }

        // },
        {
            title: '基础版',
            dataIndex: 'basics',
            key: 'basics',
            width: 220,
            className: 'column-money',
        },
        {
            title: '尊享版',
            dataIndex: 'respected',
            key: 'respected',
            width: 220,
            className: 'column-money',
        },
    ],
    body: [
        {
            key: '1',
            title: '价格',
            basics: '200元/月',
            respected: '500元/月',
        },
        //   {
        //     key: '2',
        //     basics: '2000元/年',
        //     respected: '5000元/年',
        //   },
        //   {
        //     key: '3',
        //     title: '流量分析',
        //     msg:'实时访客',
        //     basics: '√',
        //     respected: '√',
        //   },
        //   {
        //     key: '4',
        //     msg:'趋势分析',
        //     basics: '√',
        //     respected: '√',
        //   },
        //   {
        //     key: '5',
        //     title: '来源分析',
        //     msg:'全部来源',
        //     basics: '√',
        //     respected: '√',
        //   },
        //   {
        //     key: '6',
        //     msg:'搜索引擎',
        //     basics: '√',
        //     respected: '√',
        //   },
        //   {
        //     key: '7',
        //     msg:'外部链接',
        //     basics: '√',
        //     respected: '√',
        //   },
        {
            key: '2',
            title: '分析链接',
            msg:'分析链接',
            basics: '3000条/月',
            respected: '10000条/月',
        },
        //   {
        //     key: '9',
        //     msg:'受访域名',
        //     basics: '√',
        //     respected: '√',
        //   },
        //   {
        //     key: '10',
        //     title: '访客分析',
        //     msg:'地域分布',
        //     basics: '√',
        //     respected: '√',
        //   },{
        //     key: '11',
        //     msg:'系统环境',
        //     basics: '√',
        //     respected: '√',
        //   },

    ]
};